"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceStateEnum = void 0;
var UserServiceStateEnum;
(function (UserServiceStateEnum) {
  /** Индивидуальное занятие (для одного участника) */
  UserServiceStateEnum["individual"] = "individual";
  /** Групповое занятие (для нескольких участников) */
  UserServiceStateEnum["group"] = "group";
  /** Разовое занятие */
  UserServiceStateEnum["onetime"] = "onetime";
  /** Регулярное занятие */
  UserServiceStateEnum["ongoing"] = "ongoing";
  /** Серия занятий (курс/миникурс) */
  UserServiceStateEnum["series"] = "series";
  /** Находится в черновиках */
  UserServiceStateEnum["draft"] = "draft";
  /** Отправлена в архив */
  UserServiceStateEnum["archived"] = "archived";
  /** Находится на модерации */
  UserServiceStateEnum["on_moderation"] = "on_moderation";
  /** Одобрена при модерации */
  UserServiceStateEnum["approved"] = "approved";
  /** Отклонена при модерации */
  UserServiceStateEnum["declined"] = "declined";
  /** Для услуги используется расписание */
  UserServiceStateEnum["schedulable"] = "schedulable";
})(UserServiceStateEnum = exports.UserServiceStateEnum || (exports.UserServiceStateEnum = {}));
